var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCleanlinessIconcomponent = function SvgCleanlinessIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5c0 .825-.675 1.5-1.5 1.5S12 5.325 12 4.5 12.675 3 13.5 3s1.5.675 1.5 1.5Zm-12 3C3 6.675 3.675 6 4.5 6S6 6.675 6 7.5 5.325 9 4.5 9 3 8.325 3 7.5Zm3 3C6 9.675 6.675 9 7.5 9S9 9.675 9 10.5 8.325 12 7.5 12 6 11.325 6 10.5ZM4.5 12c-.825 0-1.5.675-1.5 1.5S3.675 15 4.5 15 6 14.325 6 13.5 5.325 12 4.5 12Zm6 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5Zm1.5-1.5c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5ZM10.5 6C9.675 6 9 6.675 9 7.5S9.675 9 10.5 9 12 8.325 12 7.5 11.325 6 10.5 6ZM6 4.5C6 3.675 6.675 3 7.5 3S9 3.675 9 4.5 8.325 6 7.5 6 6 5.325 6 4.5Z",
    fill: "#CECCC9"
  })));
};
export default SvgCleanlinessIconcomponent;